<template>
  <div>
    <!--<div ref="editor" style="text-align:left;"></div>
    <dragger :disabled="false" @uploader="uploader">-->
    <div ref="toolbar"
         class="toolbar">
    </div>
    <div ref="editor"
         id="editor"
         class="text"
         :style="{height:height+ 'px'}">
      <!-- <p style="color: #999;">故障描述：</p> -->
    </div>
  </div>
</template>

<script>
import E from "redcoral-wangeditor";
import dragger from './dragger'
export default {
  name: "wangeditor",
  components:{
    dragger
  },
  data() {
    return {
      editor: null,
      content: null
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    },
    //高度
    height: {
      type: Number,
      default: 200
    }
  },
  watch: {
    isClear(val) {
      //出发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.content = null;
      }
    },
    value(val) {
      //使用v-model时，设置初始化
      // this.editor.txt.html(val);
    }
  },
  methods: {
    reset(){
      this.editor.txt.clear();
      this.content = null;
    },
    getContent: function() {
      return this.content;
    },
    setContent: function(txt) {
      this.content = txt;
      this.editor.txt.html(txt);
      this.editor.change && this.editor.change()
    },
    setAppendContent: function(val) {
      //替换
      this.editor.txt.append(val);
      this.editor.change && this.editor.change()
      //  this.editor.cmd.do("insertHTML", val);
    },
    getSelectionText() {
      //获取选中的文字
      return this.editor.selection.getSelectionText();
    },
    getSelectionContainerElem() {
      //获取选取所在的 DOM 节点
      return this.editor.selection.getSelectionContainerElem()[0];
    },
    getSelectionStartElem() {
      //开始节点
      return this.editor.selection.getSelectionStartElem()[0];
    },
    getSelectionEndElem() {
      //结束节点
      return this.editor.selection.getSelectionEndElem()[0];
    },
    saveRange(_range) {
      //保存选区
      this.editor.selection.saveRange(_range);
    },
    getRange() {
      //获取 range 对象
      return this.editor.selection.getRange();
    },
    isSelectionEmpty() {
      //选区是否为空
      return this.editor.selection.isSelectionEmpty();
    },
    uploader(files){
      this.$emit('uploader',files)
      // onFileAdded
    }
  },
  mounted() {
    E.fullscreen = {
      // editor create之后调用
      init: function(editorSelector) {
        $(editorSelector + " .w-e-toolbar").append(
          '<div class="w-e-menu"><a class="_wangEditor_btn_fullscreen" href="###" onclick="E.fullscreen.toggleFullscreen(\'' +
            editorSelector +
            "')\">全屏</a></div>"
        );
      },
      toggleFullscreen: function(editorSelector) {
        $(editorSelector).toggleClass("fullscreen-editor");
        if (
          $(editorSelector + " ._wangEditor_btn_fullscreen").text() == "全屏"
        ) {
          $(editorSelector + " ._wangEditor_btn_fullscreen").text("退出全屏");
        } else {
          $(editorSelector + " ._wangEditor_btn_fullscreen").text("全屏");
        }
      }
    };
    this.editor = new E(this.$refs.toolbar, this.$refs.editor);
    this.editor.customConfig.zIndex = 100;
    this.editor.customConfig.uploadImgShowBase64 = true; // 使用 base64 保存图片
    this.editor.customConfig.pasteIgnoreImg = true;
    this.editor.customConfig.onchange = html => {
      var left_br = html.indexOf("<p><br></p>");
      if(left_br == 0){
        html=html.slice(11)
      }
      console.log("onchange", html);
      this.content = html;
      this.$emit("change", html);
    };
    // this.editor.customConfig.onblur = html => {
    //    this.editor.change();
    // }
    this.editor.create();
    E.fullscreen.init("#editor");
  }
};
</script>

<style scoped>
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  text-align: left;
}
</style>
